/**
 * 「院内ネットワーク限定（403 + INTERNAL_NETWORK_ONLY）」エラーの判定ユーティリティ
 *
 * backend の requireInternalNetwork ミドルウェアは、遠隔（Tailscale 100.x / ULA / 不明IP）
 * からの upload / download 操作に対して 403 { code: 'INTERNAL_NETWORK_ONLY' } を返す。
 * これは「認証切れ」ではなく接続元ポリシーによる拒否であり、
 * セッションを破棄してはならない（破棄するとログアウトになる / MT 院外削除ログアウト事象）。
 *
 * 呼び出し元が axios / fetch のどちらでもこの判定を共有できるよう、両方の形を見る:
 *   - axios: error.response?.status === 403 && error.response?.data?.code === 'INTERNAL_NETWORK_ONLY'
 *   - fetch: throw されたエラーに status / code が付与されている場合を拾う
 *     （chunkUploadService が response.status / errorData.code を Error に載せて throw する形）
 */

/** backend が接続元ゲートで返すエラーコード（requireInternalNetwork と対で維持すること） */
export const INTERNAL_NETWORK_ONLY_CODE = 'INTERNAL_NETWORK_ONLY';

/**
 * エラーが「院内ネットワーク限定による拒否」かどうかを判定する
 *
 * @param error catch で受け取った不明な型のエラー
 * @returns 403 + code='INTERNAL_NETWORK_ONLY' なら true
 */
export const isInternalNetworkOnlyError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  // axios エラー形式: error.response.status / error.response.data.code
  const axiosLike = error as {
    response?: { status?: number; data?: { code?: string } };
  };
  if (
    axiosLike.response?.status === 403 &&
    axiosLike.response?.data?.code === INTERNAL_NETWORK_ONLY_CODE
  ) {
    return true;
  }

  // fetch 経路でステータス/コードを付与して throw された形式
  const fetchLike = error as { status?: number; code?: string };
  if (fetchLike.status === 403 && fetchLike.code === INTERNAL_NETWORK_ONLY_CODE) {
    return true;
  }

  return false;
};
